export function parseCron(expr) {
    if (!expr || typeof expr !== "string") {
        return { frequency: "minutes", every: 5, minute: 0, hour: 0 };
    }

    const parts = expr.trim().split(/\s+/);
    if (parts.length !== 5) {
        return { frequency: "minutes", every: 5, minute: 0, hour: 0 };
    }

    const [minutePart, hourPart, dayPart] = parts;

    // Every X days: M H */X * *
    if (dayPart.startsWith("*/")) {
        return {
            frequency: "days",
            every: parseInt(dayPart.slice(2)) || 1,
            minute: parseInt(minutePart) || 0,
            hour: parseInt(hourPart) || 0,
        };
    }

    // Every X hours: M */X * * *
    if (hourPart.startsWith("*/")) {
        return {
            frequency: "hours",
            every: parseInt(hourPart.slice(2)) || 1,
            minute: parseInt(minutePart) || 0,
            hour: 0,
        };
    }

    // Every X minutes: */X * * * *
    if (minutePart.startsWith("*/")) {
        return {
            frequency: "minutes",
            every: parseInt(minutePart.slice(2)) || 5,
            minute: 0,
            hour: 0,
        };
    }

    // Fixed daily: M H * * *
    if (minutePart !== "*" && hourPart !== "*" && dayPart === "*") {
        return {
            frequency: "days",
            every: 1,
            minute: parseInt(minutePart) || 0,
            hour: parseInt(hourPart) || 0,
        };
    }

    // Fixed hourly: M * * * *
    if (minutePart !== "*" && hourPart === "*") {
        return {
            frequency: "hours",
            every: 1,
            minute: parseInt(minutePart) || 0,
            hour: 0,
        };
    }

    return { frequency: "minutes", every: 5, minute: 0, hour: 0 };
}

export function buildCron(schedule) {
    const { frequency, every = 1, minute = 0, hour = 0 } = schedule;
    switch (frequency) {
        case "minutes":
            return `*/${every} * * * *`;
        case "hours":
            return `${minute} */${every} * * *`;
        case "days":
            return every === 1
                ? `${minute} ${hour} * * *`
                : `${minute} ${hour} */${every} * *`;
        default:
            return "*/5 * * * *";
    }
}

const pad = (n) => String(n).padStart(2, "0");

export function describeCron(expression) {
    const s = parseCron(expression);
    switch (s.frequency) {
        case "minutes":
            return `Co ${s.every} min`;
        case "hours":
            return s.every === 1
                ? `Co godzine o :${pad(s.minute)}`
                : `Co ${s.every}h o :${pad(s.minute)}`;
        case "days":
            return s.every === 1
                ? `Codziennie o ${pad(s.hour)}:${pad(s.minute)}`
                : `Co ${s.every} dni o ${pad(s.hour)}:${pad(s.minute)}`;
        default:
            return expression;
    }
}